import { Navigate } from "react-router-dom";
import { ROUTES } from "@/lib/routes";

/** Mega-dashboard removed — product entry is Borrow. */
export default function DashboardPage() {
	return <Navigate to={ROUTES.borrow} replace />;
}
